// application
import { AxiosResponse } from 'axios';
import { Result } from '@/main/models/common/resultResponse';

export abstract class IReCAPTCHAApi {
  abstract validateRecaptcha(
    token: string
  ): Promise<AxiosResponse<Result<boolean>>>;
}

